import type { TithelyNavSettingsItem, TithelyNavSettingsSection } from '@/types/nav/tithelyNav'
import { useMe } from '@/queries/me'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { filterNavPermissions } from '@/functions/nav'
import TRINITY_NAV_SETTINGS from '@/constants/nav/trinitySettings'

const useTithelyNavSettings = () => {
    const { data: me, isPaid } = useMe()
    const { path } = useRoute()

    const features = computed(() => me.value?.features ?? [])
    const roles = computed(() => [...(me.value?.roles ?? []), ...(me.value?.isPrimary ? [`primary`] : [])])

    const filteredNav = (section: TithelyNavSettingsSection): TithelyNavSettingsItem[] => {
        if (path === `/r/suspended`) {
            return []
        }

        return filterNavPermissions(TRINITY_NAV_SETTINGS[section], features, roles, isPaid.value)
    }

    return {
        filteredNav
    }
}

export default useTithelyNavSettings
